module.exports = __webpack_public_path__ + "img/stock2.06576674.png";